<div  style=" padding : 0px 0px 0px  0px">
  <div class=" row d-flex justify-content-center" style="margin-bottom: -10px">
    <div class="col-4 flex-grow-1"> <button type="button" class="btn btn-light btn-sm m-2 pe-none ">Status</button></div>
    <div class=" col-4 info-box " id="main" style="margin-bottom: -10px">
      <span class="info-box-icon bg-gradient-primary elevation-1 img-size">
        <i class="fa fa-cog fa-spin fa-sm" aria-hidden="true"></i>
      </span>
      <div class="info-box-content text-center">
        <span class="info-box-text">Inprocess</span>
        <span class="info-box-number ">4</span>
      </div>
    </div>
    <div class="col-4 info-box" id="main" style="margin-bottom: -10px">
      <span class="info-box-icon bg-gradient-olive elevation-1 img-size">
        <i class="fa fa-reply" aria-hidden="true"></i>
      </span>
      <div class="info-box-content text-center">
        <span class="info-box-text">Response</span>
        <span class="info-box-number ">6</span>
      </div>
    </div>
  </div>
</div>
<div style=" padding : 0px 0px 0px  0px">
  <div class=" row d-flex justify-content-center" style="margin-bottom: -10px">
    <div class="col-4 flex-grow-1"> <button type="button" class="btn btn-light btn-sm m-2 pe-none ">Status</button></div>
    <div class=" col-4 info-box " id="main" style="margin-bottom: -10px">
      <span class="info-box-icon bg-gradient-primary elevation-1 img-size">
        <i class="fa fa-cog fa-spin fa-sm" aria-hidden="true"></i>
      </span>
      <div class="info-box-content text-center">
        <span class="info-box-text">Inprocess</span>
        <span class="info-box-number ">4</span>
      </div>
    </div>
    <div class="col-4 info-box" id="main" style="margin-bottom: -10px">
      <span class="info-box-icon bg-gradient-olive elevation-1 img-size">
        <i class="fa fa-reply" aria-hidden="true"></i>
      </span>
      <div class="info-box-content text-center">
        <span class="info-box-text">Response</span>
        <span class="info-box-number ">6</span>
      </div>
    </div>
  </div>
</div>
<div style=" padding : 0px 0px 0px  0px">
  <div class=" row d-flex justify-content-center" style="margin-bottom: -10px">
    <div class="col-4 flex-grow-1"> <button type="button" class="btn btn-light btn-sm m-2 pe-none ">Status</button></div>
    <div class=" col-4 info-box " id="main" style="margin-bottom: -10px">
      <span class="info-box-icon bg-gradient-primary elevation-1 img-size">
        <i class="fa fa-cog fa-spin fa-sm" aria-hidden="true"></i>
      </span>
      <div class="info-box-content text-center">
        <span class="info-box-text">Inprocess</span>
        <span class="info-box-number ">4</span>
      </div>
    </div>
    <div class="col-4 info-box" id="main" style="margin-bottom: -10px">
      <span class="info-box-icon bg-gradient-olive elevation-1 img-size">
        <i class="fa fa-reply" aria-hidden="true"></i>
      </span>
      <div class="info-box-content text-center">
        <span class="info-box-text">Response</span>
        <span class="info-box-number ">6</span>
      </div>
    </div>
  </div>
</div>
<div id="divDataList">
  <button type="button" id="btnLoadList" (click)="getJournalAllList()" style="display:none">Refresh</button>
  <button type="button" id="btnColSave" class="btn btn-block btn-primary float-sm-right" style="display:none">Columns</button>
  <button type="button" id="btnAddNew" class="btn btn-block btn-primary float-sm-right" (click)="NavigateToDefectMgt()" style="display:none">Add New</button>
  <button type="button" id="btnPopupDT" class="btn btn-block btn-primary float-sm-right" (click)="ShowDataResponse()" style="display:none">POP-UP</button>
  <table #dataTable class="display" style="width:100%;"></table>
</div>



<!--modal begins-->


<div class="modal myModalView" id="myModal" [style.display]="showModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Defect Management Response Details</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
      </div>


      <div class="modal-body DetailScroll">
        <div class="row">
          <div class="col-sm-6">

            <table class="tblBkinfo tblMain table table-bordered" width="100%" id="tbldefectmanagement">
              <tbody>
                <tr>
                  <td class="main w-25"><b>Journal</b></td>
                  <td>{{journalName}}</td>

                </tr>

                <tr>
                  <td class="main w-25"><b>Issue</b></td>
                  <td>{{volumeIssue}}</td>
                </tr>

                <tr>
                  <td class="main w-25"> <b>Article</b></td>
                  <td>{{articleNo}}</td>
                </tr>
                <tr>
                  <td class="main w-25"> <b>Defect Area</b></td>
                  <td>{{defectAreaName}}</td>
                </tr>
                <tr>
                  <td class="main w-25"> <b>Defect Category</b></td>
                  <td>{{defectCategory}}</td>
                </tr>
                <tr>
                  <td class="main w-25"><b>Defect Instruction</b></td>
                  <td>{{defectInstructions}}</td>
                </tr>

              </tbody>
            </table>
          </div>

          <div class="col-sm-6">

            <table class="tblBkinfo tblMain table table-bordered" width="100%" id="tbldefectmanagement1">
              <tbody>
                <tr>

                  <td class="main w-25"><b>Complaint Type</b></td>
                  <td>
                    {{complaintType}}
                  </td>

                </tr>
                <tr>
                  <td class="main w-25"><b>Critical Level</b></td>
                  <td>
                    {{criticalStatus}}
                  </td>
                </tr>
                <tr>
                  <td class="main w-25"><b>Current Status</b></td>
                  <td>
                    {{currentStatus}}
                  </td>
                </tr>
                <tr>
                  <td class="main w-25"><b>Problem Date</b></td>
                  <td>
                    {{problemDate}}
                  </td>
                </tr>
                <tr>
                  <td class="main w-25"><b>Implement Date</b></td>
                  <td>
                    {{implementDate}}
                  </td>
                </tr>
                <tr>
                  <td class="main w-25"><b>Responsible User</b></td>
                  <td>
                    {{responsibleUser}}
                  </td>

                </tr>


              </tbody>
            </table>
          </div>
        </div>
        <br />

        <br />


        <div [ngSwitch]="dueStatus" style=" padding : 0px 0px 0px  0px">
          <div *ngSwitchCase="'OverDue'" style=" padding : 0px 0px 0px  0px">
            <div class="alert alert-danger alert-dismissible fade show" role="alert" id="divduestatus">
              <strong>Defect DueDate :  {{defectDueDate }}  -  {{dueStatus}}</strong>
              The defect is due for response. Kindly close the response at the earliest!!!
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div *ngSwitchCase="'OnDue'" style=" padding : 0px 0px 0px  0px">

            <div class="alert alert-warning alert-dismissible fade show" role="alert" id="divduestatus">
              <strong>Defect DueDate | DueStatus:  {{defectDueDate }}  -  {{dueStatus}}</strong>
              Your Defect Response is due for Today!!! Kindly close the response at the earliest!!!
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div *ngSwitchCase="'0'" style=" padding : 0px 0px 0px  0px">

            <div class="alert alert-primary alert-dismissible fade show" role="alert" id="divduestatus">
              <strong> Your Defect Response is already closed!!!</strong>

              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div *ngSwitchDefault>

            <div class="alert alert-success alert-dismissible fade show" role="alert" id="divduestatus">
              <strong>Defect DueDate | DueStatus:  {{defectDueDate }}  -  {{dueStatus}}</strong>
              You have days left to complete your response !!!
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </div>



        <br />
        <div class="row border-top-0">
          <div class="col">
            <div>
              <div class="row ">
                <div class="col text-muted">  <label>Description</label></div>

              </div>
              <div class="row shadow-sm pt-3 mb-1 rounded border border-3 ">
                <div class="description text-muted">{{description}}</div>
              </div>
            </div>
          </div>
        </div>
        <br />





        <div class="row border-top-0">
          <div class="col">
            <div>
              <div class="row ">
                <div class="col text-muted"> <label>Root Cause :</label></div>
                <div class="col align-content-end text-muted"><label> RootCause User :{{rootCauseBy}}</label> </div>
                <div class="col align-content-end text-muted"> <label>RootCause Date: {{rootCauseDate}}</label></div>
              </div>
              <div class="row shadow-sm pt-3 mb-1 rounded border border-3  ">
                <div class="description ">{{rootCause}}</div>
              </div>
            </div>
          </div>
        </div>
        <br />


        <div class="row border-top-0 ">
          <div class="col ">
            <div>
              <div class="row ">
                <div class="col text-muted"> <label>Preventive Action:</label></div>
                <div class="col align-content-end text-muted"><label> PreventiveAction User :{{preventiveActBy}}</label> </div>
                <div class="col align-content-end text-muted"> <label>PreventiveAction Date:{{preventiveActDate}}</label></div>
              </div>
              <div class="row shadow-sm pt-3 mb-1 rounded  border border-3">
                <div class="description">{{preventiveAct}}</div>
              </div>
            </div>
          </div>
        </div>
        <br />


        <div class="row  border-top-0">
          <div class="col">
            <div>
              <div class="row ">
                <div class="col text-muted"> <label>Corrective Action:</label></div>
                <div class="col align-content-end text-muted"><label> Corrective User :{{correctiveActBy}}</label> </div>
                <div class="col align-content-end text-muted"> <label>Corrective Date:{{correctiveActDate}}</label></div>
              </div>
              <div class="row shadow-sm pt-3 mb-1 rounded border border-3">
                <div class="description ">{{correctiveAction}}</div>
              </div>
            </div>
          </div>
        </div>
        <br />


        <div class="row  border-top-0">
          <div class="col">
            <div>
              <div class="row ">
                <div class="col text-muted">   <label>Comments:</label>></div>

              </div>
              <div class="row shadow-sm pt-3 mb-1 rounded border border-3">
                <div class="description "> {{feedback}}</div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <hr />










      </div>

    </div>



  </div>
  <div class="modal-footer">
    <!--<button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>-->

  </div>
</div>


<div id="LoadingImagePopup">
  <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
</div>





